import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": []
}
const adminBlockUser = createSlice({
    name:'adminBlockUser',
    initialState,
    reducers:{
        addAdminBlock: (_state,payload)=>{
            return {
                "id" : uuidv4(),
                "data": payload.payload
            }
        }
    }
});

export default adminBlockUser.reducer
export const addAdminBlock = adminBlockUser.actions.addAdminBlock